
import './AssureursBailleurModal.css';
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PrimaryBtnOutlineAction, SecondaryBtnOutlineAction, CancelBtnOutlineAction } from '../../styles/Common';
import { useTheme } from 'styled-components';
import { TH, THead, TBody, Table, TD } from '../../styles/Table.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { EIFormCol, EIFormContainer } from '../../containers/Entity/Entity.styled';
import { FormGroup, FormInput, FormLabel, TelInput, FormSelect } from '../../styles/Common';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import CancelIcon from '@mui/icons-material/Cancel';
import Axios from '../../axios-proas'
import { EntContainer, EntContent, EntHeader, EntHeaderActions, EntHeaderTitle2, EntHeaderTitle, EntHeaderTitleDiv, EntFormList, EntHeaderWrapper, EIFormContainer2, EntFormItem, OptionDiv, OptionContainer } from '../../containers/UserForm/UserForm.styled'
import { getNotyfObject } from '../../shared/utility';

function AssureursBailleurModal({ show, modalClosed, title, data, getAssureurs,uid, cancel}) {
    const {t} = useTranslation();
    const theme = useTheme()
    const [assureurs, setAssureurs] = useState([]);
    const notyf = getNotyfObject();
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        setAssureurs(data)
        return () => {
        }
    }, [data])

    const checkFormValidity = (codesToAdd) => {
        let errors = []
        if (codesToAdd?.some(item => item.codeExterne == null || item.libelle==null) ) {
            errors.push("Le code interne ou le libelle est vide ou non valide");
        }
        return errors;
    }

    const saveClickHandler = async () => {
        let assureursToDelete = assureurs.filter(item => item.isToDelete) ?? []
        let assureursToAdd = assureurs.filter(item => item.new && !item.id) ?? []
        let assureursToUpdate = assureurs.filter(item => item.isUpdate && item.id) ?? []
        var checkErrors = checkFormValidity(assureursToAdd.concat(assureursToUpdate))
        if (checkErrors && checkErrors.length > 0) {
            setErrors(checkErrors);
        } else {
            setErrors([])
            try {
                const response = await Axios.post(import.meta.env.VITE_PREFIX_SERVER_API + "bailleurs/updateassureurs", {
                    assureursToDelete,
                    assureursToUpdate,
                    assureursToAdd
                });
                getAssureurs(uid)
                notyf.success("Sauvegarde réussie");
            } catch (error) {
                notyf.error("Erreur lors de la sauvegarde");
            }
        }
    }

    const handleInputChange = (e, index) => {
        const key = e.target.name;
        var value = e.target.value;
        if (key === "actif") {
            value = value === "true";
        }
        setAssureurs((prevState) => {
            let newAssureurs = [...prevState]
            newAssureurs[index] = { ...newAssureurs[index], [key]: value, isUpdate: true }
            return newAssureurs
        })
    }

    const confirmeDeleteLevel = (index) => {
        let assureursTemp = assureurs?.sort((a, b) => {
            const aIdNull = a.id == null;
            const bIdNull = b.id == null;

            if (aIdNull && !bIdNull) return -1;
            if (!aIdNull && bIdNull) return 1;

            const aCodeNull = a.codeExterne == null;
            const bCodeNull = b.codeExterne == null;

            if (aCodeNull && !bCodeNull) return -1;
            if (!aCodeNull && bCodeNull) return 1;

            return (a.id ?? 0) - (b.id ?? 0);
        });

        if (assureursTemp[index].new == true) {
            let tempSteps = [...assureursTemp]
            tempSteps.splice(index, 1)
            setAssureurs(tempSteps)
        } else {
            setAssureurs((prevState) => {
                let newAssureurs = [...assureursTemp]
                newAssureurs[index] = { ...newAssureurs[index], isToDelete: true }
                return newAssureurs
            })
        }

    }

    const addNewStep = (e) => {
        e.preventDefault();
        let p = { new: true, bailleurId: uid, codeInterne: null, actif: true };
        let assureursTemp = [p,...assureurs];
       // assureursTemp.push(p);
        //var data = assureursTemp?.sort((a, b) => {
        //    const aIdNull = a.id == null;
        //    const bIdNull = b.id == null;

        //    if (aIdNull && !bIdNull) return -1;
        //    if (!aIdNull && bIdNull) return 1;

        //    const aCodeNull = a.codeExterne == null;
        //    const bCodeNull = b.codeExterne == null;

        //    if (aCodeNull && !bCodeNull) return -1;
        //    if (!aCodeNull && bCodeNull) return 1;

        //    return (a.id ?? 0) - (b.id ?? 0);
        //});
        setAssureurs(assureursTemp)
    }

    const body = useMemo(() => assureurs.map((code, index) => (
        <tr key={index} style={{ display: code.isToDelete ? "none" : "flex", width: "100%", justifyContent: "space-between" }} >
                <TD style={{ width: "8%", paddingTop: "5px" }}>
                </TD>
                <TD style={{ width: "27%", paddingTop: "5px" }}>
                    <FormGroup>
                        <FormInput
                            style={{ textAlign: "left" }}
                            id="codeExterne"
                            type="text"
                            name="codeExterne"
                            value={code?.codeExterne || ""}
                            onChange={(e) => handleInputChange(e, index)}
                        />
                    </FormGroup>

                </TD>
                <TD style={{ width: "27%", paddingTop: "5px" }}>
                    <FormGroup>
                        <FormInput
                            style={{ textAlign: "left" }}
                            id="libelle"
                            type="text"
                            name="libelle"
                            value={code?.libelle || ""}
                            onChange={(e) => handleInputChange(e, index)}
                        />
                    </FormGroup>

                </TD>

                <TD style={{ width: "22%", paddingTop: "5px" }}>
                    <FormGroup>
                        <FormSelect
                            id="actif"
                            name="actif"
                            value={code?.actif ??""}
                            onChange={(e) => handleInputChange(e,index)}
                        >
                            <option  value={false}>Non</option>
                            <option  value={true}>Oui</option>
                            
                        </FormSelect>
                    </FormGroup>
                </TD>

                 <TD style={{ width: "8%", paddingTop: "5px" }}>
                    {!code.id &&
                        <CancelIcon onClick={(e) => confirmeDeleteLevel(index, assureurs)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />
                    }
                </TD>
            </tr>


        )), [assureurs])

    return (
        <>
            <Modal show={show} onHide={modalClosed} contentClassName="modal_w_mc_2" >
                <Modal.Header closeButton>
                <Modal.Title className="ICDBlue"> {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="ADMCreationModal__body" >

                    <EntHeaderWrapper>
                        <EntHeaderTitleDiv>
                            <EntHeaderTitle style={{ marginLeft: "10px" }} color={theme.colors.secondary}>Liste des assureurs
                           </EntHeaderTitle>
                        </EntHeaderTitleDiv>
                        <EntHeaderActions>
                            <PrimaryBtnOutlineAction
                                style={{ backgroundColor: theme.colors.success }}
                                bd={theme.colors.success}
                                onClick={saveClickHandler}
                            >
                                <span>Valider</span>
                            </PrimaryBtnOutlineAction>
                            <CancelBtnOutlineAction
                                color={theme.colors.danger}
                                border={theme.colors.danger}
                                onClick={() => cancel()}
                            >
                                Annuler
                            </CancelBtnOutlineAction>
                        </EntHeaderActions>
                    </EntHeaderWrapper>
                    {
                        errors && errors.length > 0 ? (
                            <div className="alert alert-danger mt-2" role="alert">
                                <ul>
                                    {
                                        errors.map(error => (<li key={error}>{error}</li>))
                                    }
                                </ul>
                            </div>
                        ) : null
                    }
                        <EIFormContainer>
                            <EIFormCol style={{ width: "95%", minWidth: "650px" }}>

                                <FormGroup bd={"#fff"}>
                                
                                    <Table style={{ marginTop: "10px" }}>
                                        <THead>
                                        <tr style={{ width: "100%", display: "flex", justifyContent: "space-between", paddingTop: "5px" }}>
                                            <TH style={{ width: "10%" }} > <FontAwesomeIcon icon={faCirclePlus}
                                                style={{ display: "flex", marginLeft: "5px", marginRight: "2px", color: "#2174b980", fontSize: "1.25rem" }}
                                                onClick={e => addNewStep(e)} />
                                            </TH>
                                            <TH style={{ width: "30%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code Externe</TH>
                                            <TH style={{ width: "30%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libelle </TH>
                                            <TH style={{ width: "20%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Actif</TH>
                                          
                                            <TH style={{ width: "10%" }} >
                                            </TH>
                                               
                                            </tr>
                                    </THead>
                                    <TBody style={{ maxHeight: "600px",overflow: 'auto',display: 'block'}}>
                  
                                    </TBody>
                                    {body}
                                     
                                    </Table>
                                </FormGroup>

                            </EIFormCol>


                        </EIFormContainer>
                </Modal.Body>
                <Modal.Footer>


               

       

                   

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AssureursBailleurModal

